import { runInSandbox } from '@epicuro-next/addons/sandbox';
import { of } from 'rxjs';
import { take } from 'rxjs/operators';

export function singleItemMapper(data: unknown, mapFunction: string) {
  const mapperToRun = `(function () {
      const data = ${JSON.stringify(data)};
      ${mapFunction}
      return mapFunction(data);
    })();
  `;

  return runInSandbox(of(mapperToRun)).pipe(take(1));
}
